import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Jab bhi route change ho, top par scroll ho
    window.scrollTo({
      top: 0,
      behavior: "smooth", // "auto" bhi use kar sakte ho
    });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
